module.exports = __webpack_public_path__ + "static/schoolsforasia_map@2x-0bf3a270e11e3ff1fef47a48433a89dc.png";